<template>
  <div id="map" style="height: 570px;width:780px; margin-left: 15px;margin-top: 5px;position: relative;"></div>
</template>

<script>
import L from 'leaflet';
import commonJS from '../../common';

export default {
  name: 'GpsMap',
  props: [
    'modelIndex'
  ],
  mixins: [commonJS],
  data() {
    return {
      map: null,
      promiseInitMap: '',
      mapConfig: {
        longitude: 121.433,
        latitude: 28.662,
        mapSize: 16,
        scrollFlag: false
      },
      tempLaln: {
        start: null,
        end: null,
        move: null,
        mouseFlag: false,
        circleDom: null,
        circlePoint: null,
      },
      area: []
    };
  },
  methods: {
    /**
     * 决定初始化地图是否可以移动
     * @param flag
     */
    init(flag = true, initFlag = false) {
      this.mapConfig.scrollFlag = flag;  // 地图是否可拖动flag

      this.initMemsize();

      this.initMap();

      if (initFlag) this.initMapView();

      this.qryAllPoint(); // 初始化查询所有区域节点

    },

    initMemsize() {
      try {
        this.map.remove();
      } catch (e) {
      }
      this.area = [];
    },

    /**
     * 查询所有区域
     * return 数组[区域信息1,区域信息2]
     */
    qryAllPoint() {
      const params = {
        vo: {
          groupid: this.$parent.$parent.groupId,
          flag: 0
        },
        info: {
          neid: this.$parent.$parent.neid,
          msgid: this.msg.qryGpsArea
        },
        page: {
          pageNo: 1,
          pageSize: 15
        }
      };
      this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
        const areaArr = response.data.resultVal.result;
        if (areaArr === 0) return;
        areaArr.forEach((item) => {
          const pointDom = this._drawPoint(item.latitude, item.longitude);
          const areaItem = { // 区域对象:包括
            key: item.longitude + '-' + item.latitude + '_' + item.radius,
            gpsAreaConfigId: item.gpsAreaConfigId,
            longitude: item.longitude,
            latitude: item.latitude,
            radius: item.radius,
            pointObj: pointDom,
            pointDelPageDom: this._bindPointDeleteButton(pointDom),
            circleObj: this._drawCircle(item.latitude, item.longitude, item.radius)
          };
          this.area.push(areaItem);
        });
      });
    },

    /**
     * 初始化第一次加载地图显示上次定位位置
     */
    initMapView() {
      this.$axios.post('/lte/ems/sysmanager/map/queryConfig.html').then((response) => {
        const mapConf = response.data.resultlist;
        this.mapConfig.latitude = mapConf.centerLatitude;
        this.mapConfig.longitude = mapConf.centerLongitude;
        this.map.panTo([this.mapConfig.latitude, this.mapConfig.longitude]);
      });
    },

    /**
     * 初始化地图方法
     */
    initMap() {
      console.log('this.mapConfig.scrollFlag', this.mapConfig.scrollFlag);
      const webUrl = '/UniNM/map/{z}/{x}/{y}.png';
      const mapLayer = L.tileLayer(webUrl);
      this.map = L.map('map', {
        layers: [mapLayer],
        maxZoom: 16,
        minZoom: 9,
        scrollWheelZoom: true,   // 支持滚轮缩放
        dragging: this.mapConfig.scrollFlag,
        keyboardPanDelta: 100    // 按键盘时平移的像素
      }).setView([this.mapConfig.latitude, this.mapConfig.longitude], this.mapConfig.mapSize);
      this.drawCircle();
    },
    changeModel() {
      this.mapConfig.latitude = this.map.getCenter().lat;
      this.mapConfig.longitude = this.map.getCenter().lng;
      this.mapConfig.mapSize = this.map._zoom;
      this.mapConfig.scrollFlag = !this.mapConfig.scrollFlag;
      this.init(this.mapConfig.scrollFlag);
    },
    goLocate(lng, lat) {
      this.map.panTo([lat, lng]);
      const params = {
        centerLatitude: lat,
        centerLongitude: lng
      };
      this.$axios.post('/lte/ems/sysmanager/map/saveConfig.html', params);
    },
    drawCircle() {
      this.mouse_down();

      this.mouse_move();

      this.mouse_up();
    },
    mouse_down() {
      this.map.on('mousedown', (ev) => { // 鼠标按下事件
        if (this.mapConfig.scrollFlag) return;
        if (this.tempLaln.end === null) {  // 确保不是由于按住鼠标事件然后移出map范围内导致的事件(因为地图上松开按键_endLaln会置空)
          this.tempLaln.start = [ev.latlng.lat, ev.latlng.lng];
        }
        this.tempLaln.mouseFlag = true;
      });

    },
    mouse_up() {
      const $this = this;
      this.map.on('mouseup', (ev) => { // 鼠标松开事件
        if (this.mapConfig.scrollFlag) return;
        this.tempLaln.mouseFlag = false;
        console.log(this.tempLaln)
        if(this.tempLaln.start === null || this.tempLaln.end === null || (this.tempLaln.start[0] === this.tempLaln.end[0] && this.tempLaln.start[1] === this.tempLaln.end[1])) {
          this._memsize();
          return;
        }
        // const _tempdom = _domcc;
        this.tempLaln.end = [ev.latlng.lat, ev.latlng.lng];
        const _radius = this._getGreatCircleDistance(this.tempLaln.start[0], this.tempLaln.start[1], this.tempLaln.end[0], this.tempLaln.end[1]) / 2;
        const _circlePoint = [(this.tempLaln.start[0] + this.tempLaln.end[0]) / 2, (this.tempLaln.start[1] + this.tempLaln.end[1]) / 2];
        this.$layer.confirm({
          msg: this.$t('MCS.addConfirm'),
          btn1: {
            msg: this.$t('MCS.confirm'),
            func: () => {
              const params = {
                vo: {
                  groupid: this.$parent.$parent.groupId,
                  longitude: _circlePoint[1] + '',
                  latitude: _circlePoint[0] + '',
                  radius: _radius + ''
                },
                info: {
                  neid: this.$parent.$parent.neid,
                  msgid: this.msg.addGpsArea,
                },
                log: {
                  module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_group',
                  execFunName: 'subscriber.mcsAddGroupCall',
                  exectype: 1,
                  execData: [{
                    groupid: this.$parent.$parent.groupId,
                    longitude: _circlePoint[1] + '',
                    latitude:  _circlePoint[0] + '',
                    radius: _radius + ''
                  }]
                }
              };
              this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
                try {
                  if (this.splitResult(response.data.resultVal[0].code) === '0') {
                    this.$toast('success');
                  } else {
                    this.$toast('warning', response.data.resultVal[0].display );
                  }
                } catch (e) {
                  this.$toast('failure');
                }
                this.init(false); // 重新加载地图
              });
              this._memsize();
            }
          },
          btn2: {
            msg: this.$t('MCS.cancle'),
            func: () => {
              this._clearDomCircle(this.tempLaln.circleDom);
              this._memsize(this.mapConfig.scrollFlag);
            }
          }
        });
      });
    },
    mouse_move() {
      this.map.on('mousemove', (_now) => { //
        if (this.mapConfig.scrollFlag) return;
        if (!this.tempLaln.mouseFlag)  return;
        this.tempLaln.move = [_now.latlng.lat, _now.latlng.lng];
        this.tempLaln.end = this.tempLaln.move;
        const _radius = this._getGreatCircleDistance(this.tempLaln.start[0], this.tempLaln.start[1], this.tempLaln.end[0], this.tempLaln.end[1])/2;
        const _circlePoint = [(this.tempLaln.start[0] + this.tempLaln.end[0]) / 2, (this.tempLaln.start[1] + this.tempLaln.end[1]) / 2];
        this._clearDomCircle(this.tempLaln.circleDom);
        this._drawMoveCircle(_circlePoint, _radius);
      });
    },

    _drawPoint(la, ln) {
      const pointObj = L.marker([la, ln]);
      pointObj.addTo(this.map);
      return pointObj;
    },
    _drawCircle(la, ln, radius) {
      const circleObj = L.circle([la, ln], { radius: radius });
      circleObj.addTo(this.map);
      return circleObj;
    },
    _bindPointDeleteButton(pointDom) {
      let delDom = null;
      pointDom.on('click', (ev) => {    // 只有右键才绑定删除事件
        this.$layer.confirm({
          msg: this.$t('MCS.deleteConfirm'),
          btn1: {
            msg: this.$t('MCS.confirm'),
            func: () => {
              const laln = pointDom._latlng;
              this.area.forEach((item) => {
                if ((laln.lng + '-' + laln.lat) == item.key.split('_')[0]) {
                  const params = {
                    vo: {
                      groupid: this.$parent.$parent.groupId,
                      gpsAreaConfigId: item.gpsAreaConfigId,
                      flag: 0
                    },
                    info: {
                      neid: this.$parent.$parent.neid,
                      msgid: this.msg.delGpsArea
                    },
                    log: {
                      module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_group',
                      execFunName: 'subscriber.mcsDelGroupCall',
                      exectype: 1,
                      execData: [
                        {
                          groupid: this.$parent.$parent.groupId,
                          gpsAreaConfigId: item.gpsAreaConfigId
                        }
                      ]
                    }
                  };
                  this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
                    try {
                      if (this.splitResult(response.data.resultVal[0].code) === '0') {
                        this.$toast('success');
                      } else {
                        this.$toast('warning', response.data.resultVal[0].display );
                      }
                    } catch (e) {
                      this.$toast('failure');
                    }
                    this.init(this.mapConfig.scrollFlag); // 重新加载地图
                  });
                  return false;
                }
                return true;
              });
            }
          },
          btn2: {
            msg: this.$t('MCS.cancle'),
          }
        });
      });
      return delDom;
    },
    /**
     * 动态画圆方法
     * @param laln
     * @param radius
     * @returns {*}
     */
    _drawMoveCircle(_laln, _radius) {
      if (_laln === null || _radius === 'NAN' || _radius === 0) return;
      this.tempLaln.circleDom = L.circle(_laln, { radius: _radius });
      this.tempLaln.circleDom.addTo(this.map);
      return this.tempLaln.circleDom;
    },
    /**
     * 动态清圆方法
     * @param dom
     */
    _clearDomCircle(_dom) {
      if (_dom == null)
        return;
      _dom.remove();
    },
    /**
     * 清空参数
     * @private
     */
    _memsize(){
      this.tempLaln.circleDom = null;   // 临时圆dom
      this.tempLaln.start = null; // 起始经纬
      this.tempLaln.move = null;   // 目前经纬
      this.tempLaln.end = null;   // 结束经纬
      this.tempLaln.mouseFlag = false; // 鼠標按下标识
    },
    _getGreatCircleDistance(lat1, lng1, lat2, lng2){
      const EARTH_RADIUS = 6378137.0;
      const radLat1 = this._getRad(lat1);
      const radLat2 = this._getRad(lat2);
      const a = radLat1 - radLat2;
      const b = this._getRad(lng1) - this._getRad(lng2);
      let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
      s = s * EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000.0;

      return s;
    },
    _getRad(d) {
      const PI = Math.PI;
      return d * PI / 180.0;
    }
  },
  mounted() {
    this.init(true, false);
  }
}
</script>

<style scoped>
@import '~leaflet/dist/leaflet.css';
</style>
